import React, { useState }  from 'react'
import { Link , useHistory} from 'react-router-dom'
import Button from "@material-tailwind/react/Button";
import '../../CSS/questions.css'
import { useStateValue} from '../../StateProvider'
import '../Data/Questions.json'

const Q1 = () => {

    const [Ans,setAns] = useState();
    const [{count}, dispatch] = useStateValue();

    const [showQues1,setShowQues1] = useState(true);
    const [showQues2,setShowQues2] = useState();
    const [showQues3,setShowQues3] = useState();
    const [showQues4,setShowQues4] = useState();
    const [showQues5,setShowQues5] = useState();
    const history = useHistory();

    const [link1,setLink1Active] = useState();
    const [link2,setLink2Active] = useState();
    const [link3,setLink3Active] = useState();
    const [link4,setLink4Active] = useState();
    { /*
    let history = useHistory();

    const handleAns = (e) => {
        setAns(e.target.value);
        Ans === 'Sham' ? (
            dispatch({
                type : 'INCREMENT_COUNT',
                count : count+1
            })
        ) : (
             dispatch({
                type : 'INCREMENT_COUNT',
                count : 0
            })
        )
    }
    */}
    const handleQuestion1 = (e) => {
        setAns(e.target.value);
        Ans === 'Sham' ? (
            dispatch({
                type : 'INCREMENT_COUNT',
                count : count+1
            })
        ) : (
             dispatch({
                type : 'INCREMENT_COUNT',
                count : 0
            })
        )
        setShowQues1(false);
        setShowQues2(true);
        setLink1Active(false);
        setLink2Active(false);
        setLink3Active(false);
        setLink4Active(false);
    }

    const handleQuestion2 = (e) => {
        setAns(e.target.value);
        Ans === 'Sham' ? (
            dispatch({
                type : 'INCREMENT_COUNT',
                count : count+1
            })
        ) : (
             dispatch({
                type : 'INCREMENT_COUNT',
                count : 0
            })
        )
        setShowQues2(false);
        setShowQues3(true);
        setLink1Active(false);
        setLink2Active(false);
        setLink3Active(false);
        setLink4Active(false);
    }
    
    const handleQuestion3 = (e) => {
        setAns(e.target.value);
        Ans === 'Sham' ? (
            dispatch({
                type : 'INCREMENT_COUNT',
                count : count+1
            })
        ) : (
             dispatch({
                type : 'INCREMENT_COUNT',
                count : 0
            })
        )
        setShowQues3(false);
        setShowQues4(true);
        setLink1Active(false);
        setLink2Active(false);
        setLink3Active(false);
        setLink4Active(false);
    }
    
    const handleQuestion4 = (e) => {
        setAns(e.target.value);
        Ans === 'Sham' ? (
            dispatch({
                type : 'INCREMENT_COUNT',
                count : count+1
            })
        ) : (
             dispatch({
                type : 'INCREMENT_COUNT',
                count : 0
            })
        )
        setShowQues4(false);
        setShowQues5(true);
        setLink1Active(false);
        setLink2Active(false);
        setLink3Active(false);
        setLink4Active(false);
    }
    
    const handleQuestion5 = (e) => {
        setAns(e.target.value);
        Ans === 'Sham' ? (
            dispatch({
                type : 'INCREMENT_COUNT',
                count : count+1
            })
        ) : (
             dispatch({
                type : 'INCREMENT_COUNT',
                count : 0
            })
        )
    }

    const handleBack1 =() => {
        history.push('/take_test');
    }
    const handleBack2 =() => {
        setShowQues1(true);
        setShowQues2(false);
        setLink1Active(false);
        setLink2Active(false);
        setLink3Active(false);
        setLink4Active(false);
      
    }
    const handleBack3 =() => {
        setShowQues2(true);
        setShowQues3(false)
        setLink1Active(false);
        setLink2Active(false);
        setLink3Active(false);
        setLink4Active(false);
    }
    const handleBack4 =() => {
        setShowQues3(true);
        setShowQues4(false)
        setLink1Active(false);
        setLink2Active(false);
        setLink3Active(false);
        setLink4Active(false);
    }
    const handleBack5 =() => {
        setShowQues4(true);
        setShowQues5(false)
        setLink1Active(false);
        setLink2Active(false);
        setLink3Active(false);
        setLink4Active(false);
    }

    const handleActiveLink1 = () => {
        setLink1Active(true);
        setLink2Active(false);
        setLink3Active(false);
        setLink4Active(false);
    }
    const handleActiveLink2 = () => {
        setLink2Active(true);
        setLink1Active(false);
        setLink3Active(false);
        setLink4Active(false);
    }
    const handleActiveLink3 =() => {
        setLink3Active(true);
        setLink1Active(false);
        setLink2Active(false);
        setLink4Active(false);
    }
    const handleActiveLink4 =() => {
        setLink4Active(true);
        setLink2Active(false);
        setLink3Active(false);
        setLink1Active(false);
    }
    return (
        <>
        { showQues1 ? (
            <div className="QueDiv">
                <div className="queSubDiv">
                    <div className="queTopDiv">
                        { /*<div className="quesProgDiv">
                            <svg>
                                <circle cx="20" cy="20" r="20"></circle>
                                <circle cx="20" cy="20" r="20"></circle>
                            </svg>
                            <div className="questionsNumDiv">
                                1
                            </div>
                         </div>   */}
                         <div className="box">
                            <div className="percent">
                                <svg>
                                    <circle cx="30" cy="30" r="30"></circle>
                                    <circle cx="30" cy="30" r="30"></circle>
                                </svg>
                                <div className="number">
                                    <h5>1</h5>
                                </div>
                            </div>
                         </div>
                    </div>
                
                <h1>
                    1. The Question 1 will be displayed here ?
                </h1>
                <ol>

                    <li>
                           
                            <div className="options" onClick={handleActiveLink1}>
                                <input id={link1 ? 'activeOption' : 'option1'} type="button" value="Ram" onClick={(e) =>setAns(e.target.value)} />                         
                           </div>
                        
                    </li>
                    <li>
                         
                            <div className="options" onClick={handleActiveLink2}>
                                <input id={link2 ? 'activeOption' : 'option2'} type="button" value="Sham" onClick={(e) =>setAns(e.target.value)}/>
                            </div>
                        
                    </li>

                    <li>
                         
                            <div className="options" onClick={handleActiveLink3}>
                                <input id={link3 ? 'activeOption' : 'option23'} type="button" value="John"  onClick={(e) =>setAns(e.target.value)}/>
                            </div>
                        
                    </li>
                    <li>
                        
                            <div className="options" onClick={handleActiveLink4}>
                                <input id={link4 ? 'activeOption' : 'option4'} type="button" value="Smith"  onClick={(e) =>setAns(e.target.value)} />
                            </div>
                        
                    </li>
                </ol>
                    <div className={Ans ? "backAndNextBtn" : "backAndNextBtnW_F"}>
                        <Button id='nextButton' color="lightBlue" size="lg" ripple="light" onClick={handleBack1}>Back</Button>
                        { Ans ? (
                            <Button id='nextButton' color="lightBlue" size="lg" ripple="light" onClick={handleQuestion1}>Next</Button>
                            ): 
                            ('')
                        } 
                    </div>
                
                </div>
            </div>
        ) :
            ('')
        }
        
        {
            showQues2 ? (
                 <div className="QueDiv">
                 <div className="queSubDiv">
                     <div className="box2">
                            <div className="percent">
                                <svg>
                                    <circle cx="30" cy="30" r="30"></circle>
                                    <circle cx="30" cy="30" r="30"></circle>
                                </svg>
                                <div className="number">
                                    <h5>2</h5>
                                </div>
                            </div>
                         </div>

                        <h1>
                            2. The Question 2 will be displayed here ?
                        </h1>

                    <ol>
                        <li>
                           
                            <div className="options" onClick={handleActiveLink1}>
                                <input id={link1 ? 'activeOption' : 'option1'} type="button" value="Ram" onClick={(e) =>setAns(e.target.value)} />                         
                           </div>
                        
                            </li>
                            <li>
                                
                                    <div className="options" onClick={handleActiveLink2}>
                                        <input id={link2 ? 'activeOption' : 'option2'} type="button" value="Sham" onClick={(e) =>setAns(e.target.value)}/>
                                    </div>
                                
                            </li>

                            <li>
                                
                                    <div className="options" onClick={handleActiveLink3}>
                                        <input id={link3 ? 'activeOption' : 'option23'} type="button" value="John"  onClick={(e) =>setAns(e.target.value)}/>
                                    </div>
                                
                            </li>
                            <li>
                                
                                    <div className="options" onClick={handleActiveLink4}>
                                        <input id={link4 ? 'activeOption' : 'option4'} type="button" value="Smith"  onClick={(e) =>setAns(e.target.value)} />
                                    </div>
                                
                            </li>
                    </ol>
                    <div className={Ans ? "backAndNextBtn" : "backAndNextBtnW_F"}>
                        <Button id='nextButton' color="lightBlue" size="lg" ripple="light" onClick={handleBack2}>Previous</Button>
                        { Ans ? (
                                <Button id='nextButton' color="lightBlue" size="lg" ripple="light" onClick={handleQuestion2}>Next</Button>
                        ) : 
                            ('')
                            }
                    </div>
                    </div>
                </div>
            ) : ('')
        }
        
        {
            showQues3 ? (
                 <div className="QueDiv">
                 <div className="queSubDiv">
                    <div className="queTopDiv">
                        <div className="box3">
                            <div className="percent">
                                <svg>
                                    <circle cx="30" cy="30" r="30"></circle>
                                    <circle cx="30" cy="30" r="30"></circle>
                                </svg>
                                <div className="number">
                                    <h5>3</h5>
                                </div>
                            </div>
                         </div>
                    </div>
                    <h1>
                        3. The Questions will displayed here ?
                    </h1>
                    <ol>
                        <li>
                           
                            <div className="options" onClick={handleActiveLink1}>
                                <input id={link1 ? 'activeOption' : 'option1'} type="button" value="Ram" onClick={(e) =>setAns(e.target.value)} />                         
                           </div>
                        
                            </li>
                            <li>
                                
                                    <div className="options" onClick={handleActiveLink2}>
                                        <input id={link2 ? 'activeOption' : 'option2'} type="button" value="Sham" onClick={(e) =>setAns(e.target.value)}/>
                                    </div>
                                
                            </li>

                            <li>
                                
                                    <div className="options" onClick={handleActiveLink3}>
                                        <input id={link3 ? 'activeOption' : 'option23'} type="button" value="John"  onClick={(e) =>setAns(e.target.value)}/>
                                    </div>
                                
                            </li>
                            <li>
                                
                                    <div className="options" onClick={handleActiveLink4}>
                                        <input id={link4 ? 'activeOption' : 'option4'} type="button" value="Smith"  onClick={(e) =>setAns(e.target.value)} />
                                    </div>
                                
                            </li>
                    </ol>
                    <div className={Ans ? "backAndNextBtn" : "backAndNextBtnW_F"}>
                        <Button id='nextButton' color="lightBlue" size="lg" ripple="light" onClick={handleBack3}>Previous</Button>
                        { Ans ? (
                                    <Button id='nextButton' color="lightBlue" size="lg" ripple="light" onClick={handleQuestion3}>Next</Button>
                                ) : 
                                ('')
                            }
                    </div>
                    </div>
                </div>
    
            ) : ('')
        }
        {
            showQues4 ? (
                <div className="QueDiv">
                <div className="queSubDiv">
                   <div className="box4">
                            <div className="percent">
                                <svg>
                                    <circle cx="30" cy="30" r="30"></circle>
                                    <circle cx="30" cy="30" r="30"></circle>
                                </svg>
                                <div className="number">
                                    <h5>4</h5>
                                </div>
                            </div>
                         </div>
                    <h1>
                        
                        4. The Questions will displayed here ?
                    </h1>
                    <ol>
                         <li>
                           
                            <div className="options" onClick={handleActiveLink1}>
                                <input id={link1 ? 'activeOption' : 'option1'} type="button" value="Ram" onClick={(e) =>setAns(e.target.value)} />                         
                           </div>
                        
                            </li>
                            <li>
                                
                                    <div className="options" onClick={handleActiveLink2}>
                                        <input id={link2 ? 'activeOption' : 'option2'} type="button" value="Sham" onClick={(e) =>setAns(e.target.value)}/>
                                    </div>
                                
                            </li>

                            <li>
                                
                                    <div className="options" onClick={handleActiveLink3}>
                                        <input id={link3 ? 'activeOption' : 'option23'} type="button" value="John"  onClick={(e) =>setAns(e.target.value)}/>
                                    </div>
                                
                            </li>
                            <li>
                                
                                    <div className="options" onClick={handleActiveLink4}>
                                        <input id={link4 ? 'activeOption' : 'option4'} type="button" value="Smith"  onClick={(e) =>setAns(e.target.value)} />
                                    </div>
                                
                            </li>
                    </ol>
                    <div className={Ans ? "backAndNextBtn" : "backAndNextBtnW_F"}>
                        <Button id='nextButton' color="lightBlue" size="lg" ripple="light" onClick={handleBack4}>Previous</Button>
                        { Ans ? (                            
                                    <Button id='nextButton' color="lightBlue" size="lg" ripple="light" onClick={handleQuestion4}>Next</Button>
                                ) : 
                                ('')
                            }
                    </div>
                    </div>
                </div>
            ) : ('')
        }
        {
            showQues5 ? (
                 
                    <div className="QueDiv">
                        <div className="queSubDiv">
                            <div className="box5">
                            <div className="percent">
                                <svg>
                                    <circle cx="30" cy="30" r="30"></circle>
                                    <circle cx="30" cy="30" r="30"></circle>
                                </svg>
                                <div className="number">
                                    <h5>5</h5>
                                </div>
                            </div>
                         </div>
                        <h1>
                            
                            5. The Questions will displayed here ?
                        </h1>
                        <ol>
                            <li>
                           
                            <div className="options" onClick={handleActiveLink1}>
                                <input id={link1 ? 'activeOption' : 'option1'} type="button" value="Ram" onClick={(e) =>setAns(e.target.value)} />                         
                           </div>
                        
                            </li>
                            <li>
                                
                                    <div className="options" onClick={handleActiveLink2}>
                                        <input id={link2 ? 'activeOption' : 'option2'} type="button" value="Sham" onClick={(e) =>setAns(e.target.value)}/>
                                    </div>
                                
                            </li>

                            <li>
                                
                                    <div className="options" onClick={handleActiveLink3}>
                                        <input id={link3 ? 'activeOption' : 'option23'} type="button" value="John"  onClick={(e) =>setAns(e.target.value)}/>
                                    </div>
                                
                            </li>
                            <li>
                                
                                    <div className="options" onClick={handleActiveLink4}>
                                        <input id={link4 ? 'activeOption' : 'option4'} type="button" value="Smith"  onClick={(e) =>setAns(e.target.value)} />
                                    </div>
                                
                            </li>
                        </ol>          
                            
                            
                            <div className={Ans ? "backAndNextBtn" : "backAndNextBtnW_F"}> 
                                <Button id='nextButton' color="lightBlue" size="lg" ripple="light" onClick={handleBack5}>Previous</Button>
                                { Ans ? (
                                    <Link to='/test_result'>                            
                                        <Button color="lightBlue" size="lg" id='doneBtn' ripple="light" onClick={handleQuestion5}>Done</Button>                                                              
                                    </Link>
                                ) : 
                                    ('')
                                }
                            </div>
                           
                        </div>
                </div>
            ) : ('')
        }
        
        </>
    )
}

export default Q1
